





































import { Component, Vue } from "vue-property-decorator";
import { OptProblemResults } from "./mop_bindings";
import Problem from "./components/Problem.vue";
import Results from "./components/Results.vue";

@Component({
  components: {
    Problem,
    Results,
  },
})
export default class App extends Vue {
  results: OptProblemResults | null = null;
  hasResults(results: OptProblemResults) {
    this.results = results;
  }
}
